export const GET_INDUSTRIES_URL = '/business/api/business_info/industries';
